<template>
  <div class="page-class page-user-list">
    <h1 class="page-title text-center">{{ title }}</h1>
    <rtv
      :columns="columns"
      :rows="rtv"
      :baseUrl="baseUrl"
      :loading="loading"
      :searchItems="searchItems"
      :filterOptions="filterOptions"
      :showSearch="true"
      :showFilter="true"
      :showToolbar="true"
      :showPagination="true"
      :pagination="pagination"
      :showForm="true"
      :showDownload="true"
      @edit="onEdit"
      @delete="onDelete"
      @form="onOpenForm"
      @download="onDownload"
      emptyText="No Data Found."
      formButtonText="Create RTV"
      downloadText="Download List"
    >
    </rtv>
    <!-- :rows="complainList"-->
  </div>
</template>
<script>
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import _ from 'lodash';
import Vue from 'vue';
import rtv from '../../components/RTV.vue';

export default {
  components: { rtv },
  name: 'RTV',
  metaInfo() {
    return {
      title: 'RTV Form'
    };
  },
  data() {
    return {
      title: 'RTV Form',
      updateList: [],
      columns: [
        {
          type: 'row_num',
          headerText: '#',
          class: { 'text-center': true },
          textKey: 'index',
          width: '2%'
        },
        {
          type: 'string',
          headerText: 'Store Name',
          class: { 'text-center': true },
          textKey: 'storeName',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'RTV Date',
          class: { 'text-center': true },
          textKey: 'rtvDate',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'RTV Number',
          class: { 'text-center': true },
          textKey: 'rtvNumber',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'Article Code',
          class: { 'text-center': true },
          textKey: 'articleCode',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'Vendor Code',
          class: { 'text-center': true },
          textKey: 'vendorCode',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'Date of Pickup',
          class: { 'text-center': true },
          textKey: 'dateOfPickUp',
          width: '8%'
        },
        {
          type: 'string',
          headerText: 'Date of Dispatch',
          class: { 'text-center': true },
          textKey: 'dateOfDispatch',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'Status',
          class: { 'text-center': true },
          textKey: 'currentStatus',
          width: '8%'
        },
        {
          type: 'image',
          headerText: 'Document',
          class: { 'text-center': true },
          textKey: 'rtvDocumentUrl',
          width: '12%'
        },
        {
          type: 'functions',
          headerText: 'Functions',
          class: { 'text-center': true },
          width: '10%'
        }
      ],
      searchItems: [
        { value: 'name', text: 'Name' },
        { value: 'store_id', text: 'Store ID' },
        { value: 'store_name', text: 'Store Name' },
        { value: 'transaction_id', text: 'Transaction ID' },
        { value: 'transaction_date', text: 'Transaction Date' }
      ],
      filterOptions: [
        { value: null, text: 'Select Filter' },
        { value: 'CREATED', text: 'CREATED' },
        { value: 'CLOSED', text: 'CLOSED' },
        { value: 'IN PROGRESS', text: 'IN PROGRESS' }
      ]
    };
  },
  mounted() {
    if (_.isEmpty(this.$route.query)) {
      this.list({
        query: {
          ...this.$route.query
        }
      });
    } else {
      this.list({ query: this.$route.query });
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.list({ query: to.query });
    next();
  },
  methods: {
    ...mapActions('rtv', ['list', 'deleteOne', 'getImageUrl', 'deletedList', 'download']),
    onEdit({ row }) {
      this.$router.push(`/rtv/${row.id}`);
    },

    onDownload() {
      if (this.eneTrackerList.length) {
        let csv =
          'Row Number,Store Name,Store ID,Article Code Article Description, Complain Number Shaired By Brand, Customoer Mobile Number, CN Qunatity, Replacement Tag Number,Complain Date With Brand, Invoice Date, Invoice Number,Issue With Product, Issue Status\n';
        this.eneTrackerList.forEach((row, rowIndex) => {
          csv += `${rowIndex},${row.storeName || ''},${row.storeid || ''},${row.articleCode || ''},${
            row.articleDescription || ''
          },${row.complainNumberSharedByBrand || ''},${row.customerMobileNumber || ''},${row.cnQuantity || ''},${
            row.replacementTagNumber || ''
          },${row.complainDateWithBrand || ''},${row.invoiceDate || ''},${row.invoiceNumber || ''},${
            row.issueWithProduct || ''
          },${row.issueResolved}\n`;
        });

        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = 'EnE Tracker List.csv';
        anchor.click();
      }
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'startdate')) {
        this.download({
          query: {
            page: 1,
            page_size: 99999,
            ...this.$route.query
          }
        });
      } else {
        this.download({
          query: {
            page: 1,
            page_size: 99999,
            startdate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
            enddate: moment().format('YYYY-MM-DD')
          }
        });
      }
    },

    onDelete({ row }) {
      Vue.swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this.",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        },
        preConfirm: () => {
          this.deleteOne({
            id: row.id
          });
        }
      });
    },
    onOpenForm() {
      this.$router.push('/rtv/new');
    }
  },
  computed: {
    ...mapState('rtv', ['loading', 'baseUrl', 'pagination', 'rtv', 'imageUrl', 'deletedComplainList', 'downloadList']),
    ...mapState('darkMode', ['isDarkMode'])
  },
  watch: {
    downloadList(newValue) {
      if (newValue.length > 0) {
        let csv =
          'Row Number,Store Name,Store ID,Customer Name,Customer Mobile,Transaction ID,Complaint Number,Transaction Type,Transaction amount,Transaction Date,Transaction InProgress Date,Transaction Close Date,Status,Customer Remarks,In Progress Remarks,Approver Remarks\n';
        newValue.forEach((row, rowIndex) => {
          csv += `${rowIndex + 1},${row.storeName || ''},${row.storeId || ''},${row.customerName || ''},${
            row.customerPhone || ''
          },${row.transactionId || ''},${row.complaintNumber || ''},${row.transactionType || ''},${
            row.transactionAmount || ''
          },${row.transactionDate || ''},${row.transactionInProgressedOn || ''},${row.transactionClosedOn || ''},${
            row.currentStatus || ''
          },${row.customerRemarks ? row.customerRemarks.replace(/[\n\r\t\f\v,]/g, ' ') : ''},${
            row.inProgressRemarks ? row.inProgressRemarks.replace(/[\n\r\t\f\v,]/g, ' ') : ''
          },${row.approverRemarks ? row.approverRemarks.replace(/[\n\r\t\f\v,]/g, ' ') : ''}\n`;
        });

        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = 'Transaction_List.csv';
        anchor.click();
      }
    }
  }
};
</script>
